import { render, staticRenderFns } from "./editPlatPay.vue?vue&type=template&id=29173e4e&scoped=true&"
import script from "./editPlatPay.vue?vue&type=script&lang=js&"
export * from "./editPlatPay.vue?vue&type=script&lang=js&"
import style0 from "./editPlatPay.vue?vue&type=style&index=0&id=29173e4e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29173e4e",
  null
  
)

export default component.exports